import React from 'react'
import { Stack } from '@mui/material';
import SbcCommon from './SbcCommon';
import SbcWrapper from './SbcWrapper';

// sidebar panel for textfield
export default function SbcTextfield({
    data,
    handleIptChange,
    handleMultiIptChange,
    handleSwitchChange,
    handleSelectChange
}) {
    return (
        <SbcWrapper>
            <SbcCommon
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
            />
        </SbcWrapper>
    )
}
